/**
 * Reel-Script Admin API Service
 *
 * Communicates with the chat server's admin reel-script endpoints.
 * Auth: Uses admin JWT from sessionStorage as Bearer token.
 */

function getChatBaseUrl() {
  const override = localStorage.getItem('chatBaseUrl');
  if (override) return override;
  const env = localStorage.getItem('env') === 'true';
  return env
    ? 'https://prod-chat-module-api.dugoutlive.com'
    : 'https://chat-module-api.dugoutlive.com';
}

function getAuthHeaders() {
  const token = sessionStorage.getItem('sessionToken');
  if (!token) return {};
  return { Authorization: `Bearer ${token}`, auth: token };
}

async function handleResponse(res) {
  if (!res.ok) {
    let errorMsg = `Request failed: ${res.status}`;
    try { const body = await res.json(); errorMsg = body.message || body.error || errorMsg; } catch {}
    throw new Error(errorMsg);
  }
  return res.json();
}

/** Paginated listing across all users' reel-script conversations. */
export async function listReelScriptConversations(limit = 20, offset = 0, userId = null) {
  let url = `${getChatBaseUrl()}/admin/reel-script/conversations?limit=${limit}&offset=${offset}`;
  if (userId) url += `&userId=${encodeURIComponent(userId)}`;
  const res = await fetch(url, { credentials: 'include', headers: getAuthHeaders() });
  return handleResponse(res);
}

/** Full thread (all messages) for one conversation. */
export async function getReelScriptConversation(conversationId) {
  const res = await fetch(
    `${getChatBaseUrl()}/admin/reel-script/conversations/${conversationId}`,
    { credentials: 'include', headers: getAuthHeaders() }
  );
  return handleResponse(res);
}
